import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';

class ScheduleBudgetTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      schedule_grade_base_settings: [],
      data_modal: [],
      roles_list: {},
      base_setting_groups_select: {},
    };
    this.modalOff = this.modalOff.bind(this);
    this.showModal = this.showModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.editParameter = this.editParameter.bind(this);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.schedule_grade_base_settings !== 'undefined') {
      this.setState({
        schedule_grade_base_settings: newProps.schedule_grade_base_settings,
        base_setting_groups_select: newProps.base_setting_groups_select,
        roles_list: newProps.roles_list,
        loaded: 1,
      });
    }
  }
  showModal (value, event) {
    this.setState({ id: value.id});
    this.setState({ base_setting_id: value.base_setting_id});
    this.setState({ size: value.size});
    this.setState({ group_id: value.group_id});
    this.setState({ role_id: value.role_id});
    this.setState({ base_id: value.base_id});
    this.setState({ quantity: value.quantity});
    this.setState({ quantity_fixed: value.quantity_fixed});
    this.setState({ act_bkp_fixed: value.act_bkp_fixed});
    this.setState({ act_bkp: value.act_bkp});
    this.setState({ modal: true});
  }
  modalOff (event) {
    this.setState({ modal: false});
  }

  openModal (cell, row) {
    var self = this;
    var botao = (
      <button onClick={self.showModal.bind(self, row)} className="btn btn-primary"><i className="fa fa-fw fa-pencil"></i></button>
    );

    return botao;
  }

  editParameter(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      base_setting_id: this.state.base_setting_id,
      base_id: this.state.base_id,
      role_id: this.state.role_id,
      group_id: this.state.group_id,
      size: this.state.size,
      fixed_parameter_quantity: this.state.quantity_fixed,
      variable_parameter_quantity: this.state.quantity,
      variable_parameter_bkp: this.state.act_bkp,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/base/grupo/parametros', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.loadTabs();
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h4 className="pull-left">Orçamento</h4>
  <div className="clearfix"></div>
  <hr/>
  <BootstrapTable data={self.state.schedule_grade_base_settings} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há escalas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
    <TableHeaderColumn isKey={true} dataField="base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Base</TableHeaderColumn>
    <TableHeaderColumn dataField="group" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Grupo</TableHeaderColumn>
    <TableHeaderColumn dataField="role" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Função</TableHeaderColumn>
    <TableHeaderColumn dataField="size" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Porte</TableHeaderColumn>
    <TableHeaderColumn dataField="quantity_fixed" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Quantidade Fixa</TableHeaderColumn>
    <TableHeaderColumn dataField="quantity" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Quantidade Variável</TableHeaderColumn>
    <TableHeaderColumn dataField="act_bkp_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Considera anv backup como operacional?</TableHeaderColumn>
    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={self.openModal} width='80'>Ações</TableHeaderColumn>
  </BootstrapTable>
  <Modal show={self.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Edição de máscara de base</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>self.modalOff()}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      {self.state.modal === true ?
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={self.editParameter}>
              <h4>Editar parâmetros</h4>
              <hr/>
              <div className="row">
                <div className="col-md-4 form-group">
                  <label>Função:</label>
                  <Select
                    className="form-field-name"
                    name="role_id"
                    value={self.state.role_id}
                    searchable={true}
                    placeholder={'Selecionar função'}
                    onChange={self.handleSelectChange.bind(self, 'role_id')}
                    options={self.state.roles_list}
                    required
                  />
                </div>
                <div className="col-md-4 form-group">
                  <label>Grupo:</label>
                  <Select
                    className="form-field-name"
                    name="group_id"
                    value={self.state.group_id}
                    searchable={true}
                    placeholder={'Selecionar grupo'}
                    onChange={self.handleSelectChange.bind(self, 'group_id')}
                    options={self.state.base_setting_groups_select}
                    required
                  />
                </div>
                <div className="col-md-4 form-group">
                  <label>Porte:</label>
                  <Select
                    required
                    className="form-field-name"
                    name="size"
                    value={self.state.size}
                    searchable={true}
                    placeholder={'Selecionar porte'}
                    onChange={self.handleSelectChange.bind(self, 'size')}
                    options={[
                      {value: "PP", label: "PP"},
                      {value: "MP", label: "MP"},
                      {value: "GP", label: "GP"},
                      {value: "SMP", label: "SMP"},
                      {value: "AVI", label: "AVI"},
                    ]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 form-group">
                    <label>Quantidade fixa:</label>
                    <input type="text" className="form-control" name="quantity_fixed" value={self.state.quantity_fixed} onChange={self.handleChange.bind(self, 'quantity_fixed')} />
                </div>
                <div className="col-md-4 form-group">
                  <label>Quantidade variável(Nº AVN EM OPERAÇÃO x {self.state.quantity}): <i className="fa fa-question-circle" data-toggle="tooltip" data-placement="top" title="" data-original-title="Preencher com a razão Função/ANV em numeros. Ex.: Se a razão for de 1 para cada 2 aeronaves, o valor a ser preenchido é 0.5 (1/2). Sendo 1 para cada 3 aeronaves, o valor a ser preencido é 0.33 (1/3)." aria-describedby="tooltip153469"></i></label>
                  <input type="text" className="form-control" name="quantity" value={self.state.quantity} onChange={self.handleChange.bind(self, 'quantity')}
                   />
                </div>
                <div className="col-md-4 form-group">
                  <label>Considerar aeronave backup como operacional <i className="fa fa-question-circle" data-toggle="tooltip" data-placement="top" title="" data-original-title="Caso considere backup, o parâmetro irá calcular a necessidade variável contando com as aeronaves backup." aria-describedby="tooltip378065"></i></label>
                  <Select
                    className="form-field-name"
                    name="act_bkp"
                    value={self.state.act_bkp}
                    searchable={true}
                    placeholder={'Selecionar backup'}
                    onChange={self.handleSelectChange.bind(self, 'act_bkp')}
                    options={[
                      {value: 0, label: 'Não'},
                      {value: 1, label: 'Sim'},
                    ]}
                  />
                </div>
              </div>
              <button type={'submit'} className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Editar parametro</button>
            </form>
          </div>
        </div>
        : ''
      }
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>self.modalOff()}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <hr/>
</div>
    );
  }
}

export default ScheduleBudgetTab;



// WEBPACK FOOTER //
// ./src/Components/Schedules/Elements/ScheduleBudgetTab.js